import React, { useEffect, useRef, useState } from "react";
import { AUDIT_CALLING_DETAILS_REPORT, AUDIT_CALLING_REPORT } from "../../constants";
import axios from "axios";
import dayjs from "dayjs";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../reusable Component/Loader";
import { Box, Breadcrumbs, IconButton, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DetailsFilterComponent from "./DetailsFilterComponent";
import DataDisplayCard from "./DataDisplayCard";

const AgentCallDetails = ({}) => {
  const [loading, setLoading] = useState(false);

  const { agentName, agentNo } = useParams();

 
  const location = useLocation();
  const { prevFilters } = location.state || {}; // Access filters from the state
  
  const [callStatistics, setCallStatistics] = useState([]);
  const [metricData, setMetricData] = useState([]);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
  });
  const isInitialMount = useRef(true); // Ref to track initial mount

  // Apply `prevFilters` if available
  useEffect(() => {
    if (prevFilters) {
      console.log("Applying prevFilters:", prevFilters);
      setFilters(prevFilters);
    }
  }, []); // Runs once on mount

  // Fetch data when filters change (but skip the initial render)
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false; // Skip the first call
      return;
    }

    if (filters.startDate || filters.endDate) {
      console.log("Filters updated, fetching data:", filters);
      fetchCallStatistics();
    }
  }, [filters]); // Triggers only when filters change

  const fetchCallStatistics = () => {
    const { startDate, endDate } = filters;
    setLoading(true);

    // Determine yesterday's date
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

    // Format startDate and endDate, defaulting to yesterday if not provided
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : yesterday.format("YYYY-MM-DD");
    const formattedEndDate = endDate
      ? dayjs(endDate).format("YYYY-MM-DD")
      : yesterday.format("YYYY-MM-DD");

    // Build query params
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    queryParams.append("agentNumber", agentNo);

    axios
      .get(`${AUDIT_CALLING_DETAILS_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { summary,calls, employeeDetails } = response.data;
        setCallStatistics(employeeDetails);
        setMetricData(summary);

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setCallStatistics([]);
        setMetricData([]);
        setLoading(false);
      });
  };

  const [filterShow, setFilterShow] = useState(false);

  return (
    <>
      {loading && <Loader open={loading} />}
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link underline="hover" key="1" color="inherit" to="/calling_report">
          Incoming Call Report
        </Link>
        <Typography key="2" color="primary">
          Details
        </Typography>
      </Breadcrumbs>
      {/* Container with flex layout to align items */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          width: "100%",
        }}
      >
        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Box>

      {filterShow && (
        <DetailsFilterComponent
          filters={filters}
          setFilters={setFilters}
          setFilterShow={setFilterShow}
        />
      )}

      <DataDisplayCard callStatistics={[callStatistics]} metricData={metricData} filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading}></DataDisplayCard>
    </>
  );
};

export default AgentCallDetails;
